(function () {
  'use strict';

  angular.module('app.influencerOverview')
    .factory('influencerOverviewService', ['$q', '$http', '$rootScope',
      function ($q, $http, $rootScope) {

        var service = {};

        function checkResponse(data) {
          return data;
        }

        function getMessage(data) {
          if (data) {
            return data.message;
          }
          return false;
        }

        function handleRequest(url) {
          var deferred = $q.defer(), result = 'requestFail';
          $http.get(url)
            .success(function (data) {
              var dataRes = angular.fromJson(data);

              if (checkResponse(dataRes)) {
                deferred.resolve(dataRes);
              } else {
                deferred.reject(getMessage(dataRes) || result);
              }
            })
            .error(function () {
              deferred.reject(result);
            });

          return deferred.promise;
        }

        function getInfluencerOverviewLineChart(params) {
          var url_getInfluencerOverviewLineChart = $rootScope.apiUrl + 'home/getPerformanceReportTimeLineChart?' + $.param(params);
          return handleRequest(url_getInfluencerOverviewLineChart);
        }

        function getInfluencerOverviewKPIs(params) {
          var url_getInfluencerOverviewKPIs = $rootScope.apiUrl + 'measure/getPerformanceGlobalKPIs?' + $.param(params);
          return handleRequest(url_getInfluencerOverviewKPIs);
        }

        function getChannelAudienceKPIs(params){
            var url_getChannelAudienceKPIs = $rootScope.apiUrl + 'influencer/getChannelAudienceKPIs/' + params;
            return handleRequest(url_getChannelAudienceKPIs);
        }

        function getInfluencerPieChartAndBarChartData(blog_id, channel_id, date) {
          var params = {
            blog_id: blog_id,
            channel_id: channel_id,
            date: date
          };

          var url_getInfluencerPieChartAndBarChartData = $rootScope.apiUrl + 'measure/getInfluencerSegmentTopics?' + $.param(params);
          return handleRequest(url_getInfluencerPieChartAndBarChartData);
        }

        function getInfluencerTopMentions(blog_id, date) {
          var url_getInfluencerTopMentions = $rootScope.apiUrl + 'influencer/getInfluencerTopMentions/' + blog_id + '/' + date;
          return handleRequest(url_getInfluencerTopMentions);
        }

        function getInfluencerBlog(params){
            var url_getInfluencerBlog = $rootScope.apiUrl + 'home/getHomePageBlogPosts?' + $.param(params);
            return handleRequest(url_getInfluencerBlog);
        }


        service.getInfluencerOverviewLineChart = getInfluencerOverviewLineChart;

        service.getInfluencerOverviewKPIs = getInfluencerOverviewKPIs;

        service.getInfluencerBlog = getInfluencerBlog;

        service.getChannelAudienceKPIs = getChannelAudienceKPIs;

        service.getInfluencerPieChartAndBarChartData = getInfluencerPieChartAndBarChartData;

        service.getInfluencerTopMentions = getInfluencerTopMentions;


        return service;
      }]);

})();
